<template>
  <div>
    <label :for="inputId">
      <div class="avatar-md cursor-pointer">
        <div class="avatar-title rounded-circle bg-soft-info">
          <img :src="selectedFile.url" class="rounded-circle" />
        </div>
      </div>
    </label>
    <input :id="inputId" type="file" style="display: none" @change="onFileSelected" :disabled="uploadDisable">
  </div>
</template>

<script>
import _ from 'lodash'
import {getFileDetail} from "@/service";
import {updateFiles} from "@/helpers/common-service";
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

export default {
  props: {
    value: {
      type: [Object, String],
      default: () => {
        return {}
      }
    },
    inputId: {
      type: String,
      default: 'avatarInput'
    },
    filenamePrefix: {
      type: String,
      default: ''
    },
    uploadDisable: {
      type: Boolean,
      default: false
    },
    returnType: {
      type: String,
      default: 'id'
    }
  },
  data () {
    return {
      selectedFile: {},
    }
  },
  mounted() {
    this.initFile()
  },
  methods: {
    onFileSelected (event) {
      const file = event.target.files[0];
      // 上传文件
      NProgress.start()
      updateFiles(file, 'add', this.filenamePrefix).then(res => {
        this.selectedFile = res
        let returnVal = res.id
        if (this.returnType === 'url') {
          returnVal = res.url
        }
        this.$emit('update:modelValue', returnVal) // update parent component's v-model value
        NProgress.done()
      })
    },
    initFile() {
      if (typeof this.value == 'string' && this.returnType == 'url') {
        this.selectedFile = {
          url: this.value
        }
        return
      }
      if (!this.value || !Object.keys(this.value).length) {
        this.selectedFile = {
          url: require('@/assets/images/edit-image.png')
        }
        return
      }
      if (typeof this.value === 'object' && this.value.url) {
        this.selectedFile = _.cloneDeep(this.value)
      } else {
        // value is a fileId
        let pramas = {
          id__in: this.value,
        };
        getFileDetail(pramas).then((res) => {
          if (res && res.payload && res.payload.results) {
            let results = res.payload.results;
            this.selectedFile = results[0]
          }
        });
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        // console.log('ss',val)
        this.initFile();
      }
    },
  }
};
</script>
